// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table{
    color:rgb(134, 134, 134) !important;
    font-weight:700 !important;
}

.heading{
    font-weight: 900 !important;
}

::-webkit-scrollbar {
    display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/components/SizeChartShoe.css"],"names":[],"mappings":"AAAA;IACI,mCAAmC;IACnC,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B","sourcesContent":[".table{\n    color:rgb(134, 134, 134) !important;\n    font-weight:700 !important;\n}\n\n.heading{\n    font-weight: 900 !important;\n}\n\n::-webkit-scrollbar {\n    display: none !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
